{
  "moreActions": "Fler åtgärder"
}
